import angular from 'angular';
import isEqual from 'lodash/isEqual';
import ngPlaceholder from '../../../directives/ng-placeholder';
import throttleService from '../../../services/throttle.service';


const durationInputComponent = angular.module('ttb.widgets.durationInput.component', [
    ngPlaceholder,
    throttleService,
])
    .component('durationInput', {
        template: `
            <input class="form-control edit-input"
                type="text"
                style="width:100px;"
                ng-model="$ctrl.durationView"
                ng-change="$ctrl.change()"
                ng-blur="$ctrl.blur()"
                ng-focus="$ctrl.focus()"
                ng-disabled="$ctrl.readOnly"
                ng-model-options="{debounce: $ctrl.throttleDelay}"
                ng-placeholder="$ctrl.placeholder"
                ng-disabled
            />
            <div ng-if="$ctrl.model.invalid" class="text-danger"><small>Please use h and m suffixes (2h 30m)</small></div>
        `,
        bindings: {
            model: '=ngModel',
            formatter: '<',
            onChange: '&',
            throttleDelay: '@',
            placeholder: '<',
            onBlur: '&',
            readOnly:'<',
            onFocus: '&'
        },
        controller: DurationInput
    })
    .name;

function DurationInput($scope, $element, $timeout, throttleService) {

    const updateView = (oldValue) => {
        this.durationView = this.formatter
            ? this.formatter.format(this.model || {}, oldValue)
            : '';
    };

    const updateModel = (callAfter) => {
        let newValue = this.formatter.parse(this.durationView);
        if (!isEqual(this.model, newValue)) {
            this.model = newValue;
            if (callAfter) callAfter();
        }
    };

    const fireChange = () => {
        if (this.onChange) {
            $timeout(() => {
                this.onChange();
            }, 0);
        }
    };

    this.$onInit = () => {
        this.editing = false;
        this.throttle = throttleService.getThrottle(parseInt(0) || 0, fireChange);
        updateView('');
    };

    this.change = () => {
        updateModel(() => this.throttle.push());
    };

    this.blur = () => {
        this.editing = false;
        updateView(this.durationView);
        this.throttle.flush();
        if (this.onBlur) {
            $timeout(() => {
                this.onBlur();
            }, 0);
        }
    };

    this.focus = () => {
        this.editing = true;
        if (this.onFocus) {
            $timeout(() => {
                this.onFocus();
            }, 0);
        }
    };

    $scope.$watch('$ctrl.model', (newValue, oldValue) => {
        if (!this.editing) {
            updateView(this.durationView);
        } else {
            updateModel();
        }
    });

    this.$onChanges = (changes) => {
        updateView(this.durationView);
    }
}
DurationInput.$inject = ['$scope', '$element', '$timeout', 'throttleService'];

export default durationInputComponent;


// WEBPACK FOOTER //
// ../widgets/duration/input/duration-input.component.js